import React,{useEffect} from 'react'
import NotificationMarqueeTemplate from '../../../components/Common/NotificationMarquee'
import { useDispatch, useSelector } from "react-redux";
import * as commonActions from "../../../redux/actions/commonAction"
import { bindActionCreators } from "redux";

const NotificationMarquee = (props) => {

    useEffect(()=>{getNotificationMarqueeText();},[]);

    const commonReducer = useSelector((state) => state.commonReducer);

    const dispatch = useDispatch();

    const commonAction = bindActionCreators(commonActions, dispatch);

    const getNotificationMarqueeText = () => {
        commonAction.getNotificationMarqueeText();
    }
    return (
        <>
            <NotificationMarqueeTemplate
                notificationMarqueeText={commonReducer.notificationMarqueeText}
            />
        </>
    )
}

export default NotificationMarquee;